export default __webpack_public_path__ + "static/Plots0024-b36b3491dc59ab22899943513e546032.jpg";